import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { REPORT_TYPES } from "../../../pages/reports/constants";

export const SINGLE_CLIENT_REPORT_REDUCER_NAME = "sc-report";

const initialState = {
  page: 0,
  size: 20,
  totalCount: 0,
  reports: [],
  filters: {
    periodFrom: "",
    periodTo: "",
    clientType: "",
    clientUic: "",
    cid: "",
    name: "",
    forExport: false,
    type: REPORT_TYPES.SINGLE,
  },
  enabled: false,
  // reportsSelected
  allSelected: false,
  selected: [],
  // 'none' | 'page' | 'all'
  selectionMode: "none",
};

const singleClientReportSlice = createSlice({
  name: SINGLE_CLIENT_REPORT_REDUCER_NAME,
  initialState,
  reducers: {
    setPageSingleClientReport: (state, { payload }) => {
      state.page = parseInt(payload, 10);
    },
    setSizeSingleClientReport: (state, { payload }) => {
      state.size = parseInt(payload, 10);
    },
    setTotalCountSingleClientReport: (state, { payload }) => {
      state.totalCount = parseInt(payload, 10);
    },
    setReportsSingleClientReport: (state, { payload }) => {
      state.reports = [...payload];
    },
    setFiltersSingleClientReport: (state, { payload }) => {
      const temp = { ...state.filters };
      state.filters = { ...temp, ...payload };
    },
    setEnabledQuery: (state, { payload }) => {
      state.enabled = payload;
    },
    clearSingleClientReports: (state) => {
      state.page = initialState.page;
      state.take = initialState.take;
      state.totalCount = initialState.totalCount;
      state.filters = { ...initialState.filters };
      state.reports = initialState.reports;
      state.enabled = initialState.enabled;
      state.allSelected = initialState.allSelected;
      state.selectionMode = initialState.selectionMode;
      state.selected = initialState.selected;
    },

    removeId: (state, action) => {
      const id = action.payload;
      const index = state.selected.findIndex((e) => e === id);
      state.selected.splice(index, 1);
      state.selectionMode = "none";
    },
    addId: (state, action) => {
      const id = action.payload;
      if (!state.selected.includes(id)) {
        state.selected.push(id);
      }
      state.selectionMode = "none";
    },
    selectAll: (state) => {
      state.allSelected = true;
    },
    unSelectAll: (state) => {
      state.selected = [];
      state.allSelected = false;
      state.selectionMode = "none";
    },
    uncheckHeader: (state) => {
      state.allSelected = false;
    },
    selectAllRecords: (state) => {
      state.allSelected = true;
      state.selected = [];
      state.selectionMode = "all";
    },
    selectPage: (state, action) => {
      state.allSelected = false;
      const newIds = action.payload.filter(
        (id) => !state.selected.includes(id),
      );
      state.selected.push(...newIds);
      state.selectionMode = "page";
    },
    unSelectPage: (state, action) => {
      state.allSelected = false;
      const pageIds = action.payload;
      state.selected = state.selected.filter((id) => !pageIds.includes(id));
      if (state.selected.length === 0) {
        state.selectionMode = "none";
      } else {
        state.selectionMode = "page";
      }
    },
  },
});

export default singleClientReportSlice.reducer;

export const {
  setFiltersSingleClientReport,
  setPageSingleClientReport,
  setReportsSingleClientReport,
  setSizeSingleClientReport,
  setTotalCountSingleClientReport,
  clearSingleClientReports,
  setEnabledQuery,
  // reportsSelected
  removeId,
  addId,
  selectAll,
  unSelectAll,
  uncheckHeader,
  selectAllRecords,
  selectPage,
  unSelectPage,
} = singleClientReportSlice.actions;

export const useSelectFiltersSingleClientReport = () =>
  useSelector((state) => state[SINGLE_CLIENT_REPORT_REDUCER_NAME].filters);

export const useSelectPageSingleClientReport = () =>
  useSelector((state) => state[SINGLE_CLIENT_REPORT_REDUCER_NAME].page);

export const useSelectSizeSingleClientReport = () =>
  useSelector((state) => state[SINGLE_CLIENT_REPORT_REDUCER_NAME].size);

export const useSelectTotalCountSingleClientReport = () =>
  useSelector((state) => state[SINGLE_CLIENT_REPORT_REDUCER_NAME].totalCount);

export const useSelectReportsSingleClientReport = () =>
  useSelector((state) => state[SINGLE_CLIENT_REPORT_REDUCER_NAME].reports);

export const useSelectEnabledSingleClientReport = () =>
  useSelector((state) => state[SINGLE_CLIENT_REPORT_REDUCER_NAME].enabled);

// reportsSelected
export const useSelectAllSelected = () =>
  useSelector((state) => state[SINGLE_CLIENT_REPORT_REDUCER_NAME].allSelected);

export const useSelectSelected = () =>
  useSelector((state) => state[SINGLE_CLIENT_REPORT_REDUCER_NAME].selected);

export const useSelectSelectionMode = () =>
  useSelector(
    (state) => state[SINGLE_CLIENT_REPORT_REDUCER_NAME].selectionMode,
  );
